import React from 'react';
import { StarIcon } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="bg-ink text-white" data-id="element-174" data-mp="1ebxta3bw4yf9">
      <div className="mx-auto flex h-9 max-w-7xl items-center justify-center gap-8 px-4 text-xs sm:px-6 md:justify-between lg:px-8" data-id="element-175" data-mp="1eawgnuf883vf">
        <p className="font-medium" data-id="element-176" data-mp="1j5ik9bf2gs4y">
          <span className="text-volt" data-id="element-177" data-mp="1o2iqpnftvwwl">Free shipping</span> on orders over €50 in NL &amp; BE
        </p>
        <p className="hidden text-white/80 md:block" data-id="element-178" data-mp="rcrrjawldlkg">Ordered before 22:00, shipped today</p>
        <p className="hidden items-center gap-1.5 text-white/80 md:flex" data-id="element-179" data-mp="vctmz2bqhira">
          <StarIcon className="h-3.5 w-3.5 fill-volt text-volt" aria-hidden="true" data-id="element-180" data-mp="10cog7cizekfi" />
          <span data-id="element-181" data-mp="10f13843ljkzf">
            <span className="font-semibold text-white" data-id="element-182" data-mp="15bhtb3ucw9f5">4.8/5</span> from 6,200+ reviews
          </span>
        </p>
      </div>
    </div>;
}